import { FC, useEffect, useState } from "react";
import { Card, Modal as BSModal, Button } from "react-bootstrap";
import { OptionsOrGroups } from "react-select";
import * as Yup from "yup";
import CustomForm, { FormField } from "../../common/Form";
import { IMatchData, IPlayer } from "../../helpers/interfaces/matchData";
import Modal from '../../common/Modal';
import { matchResultForm, matchResultGoal, matchResultRequest } from "../../helpers/interfaces/match";
import { matchesService } from "../../services/MatchesService";
import "./SendResultModal.css";

const playerPointsFields: FormField[] = [
    {
        id: "team",
        name: "team",
        type: "select",
        placeholder: "Squadra",
        options: [
            {
                label: "Casa",
                value: "home"
            },
            {
                label: "Trasferta",
                value: "guest"
            }
        ],
    },
    {
        id: "player",
        name: "player",
        type: "select",
        placeholder: "Seleziona il giocatore",
        disabled: true,
        options: []
    },
    {
        id: "player_goals",
        name: "goals",
        type: "number",
        required: false,
        placeholder: "Goal",
        className: "form-control",
        disabled: true,
    },
]

interface ISendResultsModalProps {
    showModal: boolean
    currentMatch: IMatchData | undefined,
    onCloseHandler: () => void
}

const SendResultModal: FC<ISendResultsModalProps> = ({
    showModal,
    currentMatch,
    onCloseHandler
}) => {
    const [rows, setRows] = useState<FormField[][]>([]);
    const [playersA, setPlayersA] = useState<IPlayer[]>([]);
    const [playersB, setPlayersB] = useState<IPlayer[]>([]);
    const [matchResults, setMatchResults] = useState<matchResultForm>();
    const [errorMessage, setErrorMessage] = useState<string>("");
    const [responseMessage, setResponseMessage] = useState<string | undefined>(undefined);

    useEffect(() => {
        if (currentMatch) {
            setPlayersA(currentMatch.giocatoriA || [])
            setPlayersB(currentMatch.giocatoriB || [])
            const newFields = []
            for (let i = 0; i < 10; i++) {
                newFields.push([...playerPointsFields])
            }
            setRows(newFields)
        }
    }, [currentMatch])

    const pointsFields: FormField[] = [
        {
            id: "first_team_goals",
            label: <div className="d-flex pb-3"><b className="me-2">C: </b>{currentMatch?.nomeA}</div>,
            name: "goalA",
            type: "number",
            required: false,
            placeholder: "Goal eseguiti",
            className: "form-control",
            validation: Yup.number()
        },
        {
            id: "second_team_goals",
            label: <div className="d-flex pb-3"><b className="me-2">T: </b>{currentMatch?.nomeB}</div>,
            name: "goalB",
            type: "number",
            required: false,
            placeholder: "Goal eseguiti",
            className: "form-control",
            validation: Yup.number()
        }
    ]

    const isOption = (o: any): o is { label: string, value: string | number } => {
        return o && o.hasOwnProperty("label") && o.hasOwnProperty("value") && typeof o.label === "string" && (typeof o.value === "string" || typeof o.value === "number");
    }

    const onPlayerPointsChange = (
        event: React.FormEvent<HTMLFormElement> | OptionsOrGroups<any, any>,
        index: number,
        goalNumber: string | undefined
    ) => {
        if (isOption(event)) {
            if (event.value === "home" || event.value === "guest") {
                const newRows = [...rows]
                delete newRows[index]
                let currentRow = playerPointsFields.map(field => {
                    return {
                        ...field,
                        disabled: false,
                        options: field.type === "select" && field.name === "player" ? event.value === "home" ? playersA.map(player => {
                            return {
                                label: player.cognome + " " + player.nome,
                                value: player.id
                            }
                        }) : playersB.map(player => {
                            return {
                                label: player.cognome + " " + player.nome,
                                value: player.id
                            }
                        }) : field.options
                    }
                })

                newRows[index] = currentRow
                setRows(newRows)

                if (currentMatch) {
                    let idSquadra;
                    if (event.value === "home") {
                        idSquadra = currentMatch.idSquadraA
                    } else if (event.value === "guest") {
                        idSquadra = currentMatch.idSquadraB
                    }
                    
                    let newGoals = matchResults?.allGoals
                        ? [...matchResults.allGoals]
                        : [];

                    newGoals[index] = {
                        ...newGoals[index],
                        idSquadra: String(idSquadra),
                    }

                    const newMatchResults: any = {
                        ...matchResults,
                        allGoals: newGoals
                    };

                    setMatchResults(newMatchResults);
                }
            } else {
                let newGoals = matchResults?.allGoals
                    ? [...matchResults.allGoals]
                    : [];

                newGoals[index] = {
                    ...newGoals[index],
                    playerId: String(event.value)
                }

                const newMatchResults: any = {
                    ...matchResults,
                    allGoals: newGoals
                };

                setMatchResults(newMatchResults);
            }
        }

        if (goalNumber) {
            let newGoals = matchResults?.allGoals
                ? [...matchResults.allGoals]
                : [];

            newGoals[index] = {
                ...newGoals[index],
                goals: goalNumber
            }

            const newMatchResults: any = {
                ...matchResults,
                allGoals: newGoals
            };

            setMatchResults(newMatchResults);
        }
    }

    const saveResultsModal = async () => {
        if (
            currentMatch &&
            matchResults
        ) {
            let marcatoreAddA: string = '';
            let marcatoreAddB: string = '';

            matchResults.allGoals &&
            matchResults.allGoals.length > 0 && 
            matchResults.allGoals.forEach((
                goal: matchResultGoal,
                index: number
            ) => {
                if (goal) {
                    if (goal.idSquadra === String(currentMatch.idSquadraA)) {
                        if (marcatoreAddA) {
                            marcatoreAddA += '||'
                        }

                        marcatoreAddA += goal.playerId ?? ""
                    }

                    if (
                        goal.idSquadra === String(currentMatch.idSquadraB)
                    ) {
                        if (marcatoreAddB) {
                            marcatoreAddB += '||'
                        }

                        marcatoreAddB += goal.playerId ?? ""
                    }
                }
            });

            const matchResultsData: matchResultRequest = {
                lag: "risultatoInviato",
                idPartita: currentMatch.idPartita,
                idRiga: 0,
                note: matchResults.comment,
                totA: matchResults.pointsAValues,
                totB: matchResults.pointsBValues,
                marcatoreAddA,
                marcatoreAddB
            }

            if (
                matchResultsData.marcatoreAddA ||
                matchResultsData.marcatoreAddB ||
                matchResultsData.totA ||
                matchResultsData.totB ||
                matchResultsData.note 
            ) {
                await matchesService.sendResults(matchResultsData).then((
                    response: {data: number}
                ) => {
                    if (response.data === 1) {
                        setMatchResults(undefined);
                        setRows([]);
                        closeSentModalHandler();
                        setResponseMessage("Risultato inviato con successo")
                    } else {
                        return Promise.reject(new Error(''));
                    }
                }).catch(() => {
                    setResponseMessage("Si è verificato un errore durante l'invio dei risultati")
                });
            } else {
                setErrorMessage('Compilare almeno un campo!')
            }
        } else {
            setErrorMessage('Compilare almeno un campo!')
        }
    }

    function closeSentModalHandler() {
        onCloseHandler();
        setErrorMessage("");
    }

    function closeResultMessageModal() {
        setResponseMessage(undefined)
    }

    return <>
        <BSModal
            id={"sent_results_message"}
            show={responseMessage !== undefined}
            onHide={closeResultMessageModal}
            backdrop="static"
            keyboard={false}
            size={"lg"}
            centered
        >
            <div className="d-inline-block p-3">
                {responseMessage}
                <br /><br />
                <Button
                    variant="danger"
                    className="undo-btn"
                    onClick={closeResultMessageModal}
                >
                    Chiudi
                </Button>
            </div>
        </BSModal>
        <Modal
            id="send_results_modal"
            show={showModal}
            title="Invia i risultati"
            closeHandler={closeSentModalHandler}
            saveHandler={saveResultsModal}
            saveBtnLabel='Invia'
            undoBtnLabel='Indietro'
            undoBtnSize="sm"
            size="lg"
            centered
        >
            <div className="pt-3">
                <h6>Inserisci il punteggio</h6>
                <CustomForm
                    id="points_form"
                    formFields={pointsFields}
                    onSubmit={() => { }}
                    onChange={(event) => {
                        const target = (event.target as HTMLInputElement)
                        let newMatchResults: any = {
                            ...matchResults
                        };

                        if (target.name === "goalA") {
                            newMatchResults['pointsAValues'] = Number(target.value)
                            setMatchResults(newMatchResults);
                        } else if (target.name === "goalB") {
                            newMatchResults['pointsBValues'] = Number(target.value)
                            setMatchResults(newMatchResults);
                        }
                    }}
                    hideSubmitButton
                />
                <h6 className="mt-3">Punteggio marcatori</h6>
                <div className="points-scorers-labels justify-content-between py-2 pe-4 ps-2">
                    <h6>Squadra</h6>
                    <h6>Marcatore</h6>
                    <h6>Goal</h6>
                </div>
                <div className="points-scorers py-2">
                    {
                        rows.map((fields, index) =>
                            <div className="player-points-form" key={"player_points_form_" + index}>
                                <div className="player-points-form-desktop">
                                    <CustomForm
                                        id={"player_points_form_" + index}
                                        formFields={fields}
                                        onChange={(event) => {
                                            const target = (event.target as HTMLInputElement)

                                            onPlayerPointsChange(
                                                event,
                                                index,
                                                target ? target.value : undefined
                                            )
                                        }}
                                        initialValues={{}}
                                        onSubmit={() => { }}
                                        hideSubmitButton
                                    />
                                </div>
                                <div className="player-points-form-mobile">
                                    <Card>
                                        <Card.Body className="my-2 border">
                                            <h6>Dati giocatore</h6>
                                            <CustomForm
                                                id={"player_points_form_" + index}
                                                formFields={fields}
                                                onChange={(event) => {
                                                    const target = (event.target as HTMLInputElement)

                                                    onPlayerPointsChange(
                                                        event,
                                                        index,
                                                        target ? target.value : undefined
                                                    )
                                                }}
                                                initialValues={{}}
                                                onSubmit={() => { }}
                                                hideSubmitButton
                                            />
                                        </Card.Body>
                                    </Card>
                                </div>
                            </div>
                        )
                    }
                </div>
                <h6 className="mt-3">Commenti</h6>
                <CustomForm
                    id="comment_form"
                    formFields={[{
                        id: "comment",
                        name: "comment",
                        type: "textarea",
                        required: false,
                        placeholder: "Lascia un commento sulla partita",
                        className: "form-control form-control-sm",
                    }]}
                    onChange={(event) => {
                        const target = (event.target as HTMLInputElement)
                        const newMatchResults: any = {
                            ...matchResults,
                            comment: target.value
                        };

                        setMatchResults(newMatchResults);
                    }}
                    onSubmit={() => { }}
                    hideSubmitButton
                />
                <div id="sent-result-error">{errorMessage}</div>
            </div>
        </Modal>
    </>
}

export default SendResultModal;